import { ReactNode, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getIsAuth, authActions } from '@/entities/Auth';
import { useGetMyProfileQuery } from '@/entities/Profile';
import { LocalStorageService } from '@/shared/services/localStorage.service';
import { routerPath } from '@/shared/config/router';
import { useAppDispatch } from '@/shared/lib/hooks';

interface PublicRouteProps {
  children: ReactNode;
}

export const PublicRoute = ({ children }: PublicRouteProps) => {
  const dispatch = useAppDispatch();
  const isAuth = useSelector(getIsAuth);
  const accessToken = LocalStorageService.getAccessTokenFromAnyStorage();

  const hasStoredAuth =
    typeof window !== 'undefined' && !!LocalStorageService.getAccessTokenFromAnyStorage();

  const { isLoading } = useGetMyProfileQuery(undefined, {
    skip: !hasStoredAuth,
  });

  useEffect(() => {
    if (hasStoredAuth) {
      dispatch(authActions.setIsAuth(true));
    }
  }, [hasStoredAuth, dispatch]);

  // Если авторизован (после загрузки профиля) - редирект на главную
  if ((isAuth || accessToken) && !isLoading) {
    return <Navigate to={routerPath.main} replace />;
  }

  return <>{children}</>;
};
